import React, { useEffect } from 'react'
import { useGetAzpEventLinkQuery, useGetResultsBibNameSearchQuery } from '../../api/reigniteApi';
import { NotFound } from '../notFound/NotFound';
import { Loading } from '../../components/shared/Loading';

export const AzpResolver = (props: any) => {
  const { azp, azpEventId, bib, history } = props
  const { data: eventLink, error: eventLinkError, isLoading: isEventLinkLoading } = useGetAzpEventLinkQuery({
    azp,
    azpEventId,
  })
  
  const { data: bibResults, error: bibResultsError, isLoading: isBibResultsLoading } = useGetResultsBibNameSearchQuery({
    eventId: +eventLink?.athlinksEventId!,
    from: 0,
    limit: 10,
    term: bib
  }, {
    skip: !bib || !eventLink || eventLink.races.length === 0
  })

  useEffect(() => {
    if (!eventLink || eventLink.races.length === 0) return

    let redirectUrl = `/Event${bib ? '' : 's'}/${eventLink.athlinksEventId}`
    if (!bib) {
      history.replace(redirectUrl)
      return
    }

    if (!bibResults || bibResults.length === 0) return

    const findBib = bibResults.find(bibResult => bibResult.bib === bib)
    if (findBib) {
      redirectUrl += `/Course/${findBib.eventCourseId}/Bib/${bib}`
      history.replace(redirectUrl)
      return
    }
  }, [eventLink, bibResults, bib, history])

  if (eventLinkError || (!isEventLinkLoading && (!eventLink || eventLink.races.length === 0))) {
    return <NotFound errorStatus={404} />
  }

  const bibNotFound = !bibResults || bibResults.length === 0 || !bibResults.find(bibResult => bibResult.bib === bib)
  if (
    eventLink && eventLink.races.length > 0 && 
    (bibResultsError || (!isBibResultsLoading && bibNotFound))) {
    return <NotFound errorStatus={404} />
  }

  return <Loading centered={true} />
}